import { Footer } from '../homepage/Footer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AboutMessages } from './AboutPage.messages';
import { CommonMessages } from '../../i18n/Common.messages';
import { PageSeo } from '../seo/PageSeo';
import { breadcrumbSchema } from '../seo/schemas';
import './static-page.css';

export const AboutPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
    <PageSeo
      path="/about"
      localized
      titleKey="seo.about.title"
      descriptionKey="seo.about.description"
      ogImage="/og/og-default.png"
      jsonLd={[breadcrumbSchema([{ name: t(CommonMessages.BREADCRUMB_HOME), path: '/' }, { name: t(AboutMessages.BREADCRUMB), path: '/about' }])]}
    />
    <div className="page-wrapper"><div className="static-page">
      <h1>{t(AboutMessages.PAGE_TITLE)}</h1>
      <p className="page-subtitle">{t(AboutMessages.PAGE_SUBTITLE)}</p>

      <h2>{t(AboutMessages.WHAT_WE_DO_TITLE)}</h2>
      <p dangerouslySetInnerHTML={{ __html: t(AboutMessages.WHAT_WE_DO_DESC) }} />

      <h2>{t(AboutMessages.WHY_WE_BUILT_THIS_TITLE)}</h2>
      <p>{t(AboutMessages.WHY_WE_BUILT_THIS_DESC)}</p>

      <h2>{t(AboutMessages.HOW_IT_WORKS_TITLE)}</h2>
      <ul>
        <li>{t(AboutMessages.HOW_IT_WORKS_1)}</li>
        <li>{t(AboutMessages.HOW_IT_WORKS_2)}</li>
        <li dangerouslySetInnerHTML={{ __html: t(AboutMessages.HOW_IT_WORKS_3) }} />
        <li>{t(AboutMessages.HOW_IT_WORKS_4)}</li>
        <li>{t(AboutMessages.HOW_IT_WORKS_5)}</li>
      </ul>

      <h2>{t(AboutMessages.BUILT_WITH_TITLE)}</h2>
      <ul>
        <li>{t(AboutMessages.BUILT_WITH_1)}</li>
        <li>{t(AboutMessages.BUILT_WITH_2)}</li>
        <li>{t(AboutMessages.BUILT_WITH_3)}</li>
        <li>{t(AboutMessages.BUILT_WITH_4)}</li>
      </ul>
    </div>
    <Footer />
    </div>
    </>
  );
};
